/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientHistory.vue?vue&type=template&id=51b2c01b"
import script from "./PatientHistory.vue?vue&type=script&lang=js"
export * from "./PatientHistory.vue?vue&type=script&lang=js"
import style0 from "./PatientHistory.vue?vue&type=style&index=0&id=51b2c01b&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b2c01b')) {
      api.createRecord('51b2c01b', component.options)
    } else {
      api.reload('51b2c01b', component.options)
    }
    module.hot.accept("./PatientHistory.vue?vue&type=template&id=51b2c01b", function () {
      api.rerender('51b2c01b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/partials/PatientHistory.vue"
export default component.exports